import { API } from "."
import { ReadDeliveryInfoResponse, ReadDeliveryListResponse } from "@/types/delivery"

/* 호출 시 interceptor 에서 /teams/{idfTeam} 추가 */

/* 기기 배송 현황 목록 조회 */
export async function readDeliveryList() {
  return await API.get<ReadDeliveryListResponse>("/deliveries")
}

/* 기기 배송 상세 정보 조회 */
export async function readDeliveryInfo(idfTransfer: number) {
  return await API.get<ReadDeliveryInfoResponse>(`/deliveries/${idfTransfer}`)
}

/* 기기 배송 수령 */
export async function receiveDelivery({
  idfTransfer,
  deviceTypes,
}: {
  idfTransfer: number
  deviceTypes: string[]
}) {
  return await API.put<void>(`/deliveries/${idfTransfer}`, { deviceTypes })
}
